import { MainCategories } from "../MainCategories";

export enum FeedbackEvents {
  Send = MainCategories.Feedback + "Send",
}
